import { render } from "./CreditCard.vue?vue&type=template&id=079c7275&lang=html"
import script from "./CreditCard.vue?vue&type=script&lang=ts"
export * from "./CreditCard.vue?vue&type=script&lang=ts"
script.render = render

export default script